export const main_data =
{
  "datamain": [
    {
      'ID': 1,
      'DIRECTIONCODE': 1,
      'DIRECTIONNAME': 'Отправление',
      'DIRECTIONNAMEEN': 'out',
    },
    {
      'ID': 2,
      'DIRECTIONCODE': 2,
      'DIRECTIONNAME': 'Прием',
      'DIRECTIONNAMEEN': 'in',
    },
  ],
  "is_error": 0,
  "error_text": "Ошибка при получении данных ",
  "user_message_text": ""
}
export const main_data_row_empty =
{
  'ID': null,
  'DIRECTIONCODE': null,
  'DIRECTIONNAME': null,
  'DIRECTIONNAMEEN': null
}

export const main_data_empty =
{
  "datamain": [
  ],
  "is_error": 1,
  "error_text": "Ошибка при обращении к методу сервера",
  "user_message_text": ""

}

